import React from "react";
import {
  NAVIGATION_APPS,
  openNavigationApp,
} from "./navigationApps";

const NavigationPickerModal = ({
  visible,
  onClose,
  lat,
  lng,
  label,
  originLat,
  originLng,
}) => {
  if (!visible || !Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  const options = { lat, lng, label, originLat, originLng };

  return (
    <>
      <div className="bg-gray z-nn" onClick={onClose} aria-hidden="true" />
      <div className="call-modal call-modal-show navigation-picker-modal" role="dialog" aria-modal="true">
        <h3 className="font-bold text-center mb-3">انتخاب برنامه مسیریابی</h3>
        <p className="navigation-picker-subtitle text-center mb-3">
          {label}
        </p>
        <div className="navigation-picker-list d-flex flex-column gap-2">
          {NAVIGATION_APPS.map((app) => (
            <button
              key={app.id}
              type="button"
              className="navigation-picker-btn"
              onClick={() => {
                openNavigationApp(app.id, options);
                onClose();
              }}
            >
              {app.label}
            </button>
          ))}
        </div>
        <button type="button" className="navigation-picker-cancel mt-3" onClick={onClose}>
          انصراف
        </button>
      </div>
    </>
  );
};

export default NavigationPickerModal;
